export default "__VITE_ASSET__DBKwWeXs__"